import selectTodoById from '../selectors/selectTodoById';
import Todo from '../store/schema/Todo';
import { OwaDate } from 'owa-datetime';
import { mutator } from 'satcheljs';
import { updateTodo } from '../actions/todoActions';
var assign = require('object-assign');

export const updateTodoMutator = mutator(updateTodo, actionMessage => {
    const { todoUpdates, itemId } = actionMessage;
    const todoFound = selectTodoById(itemId);

    if (!todoFound) {
        return;
    }

    // Create a task that combines the old properties with the new updates.
    const todoToSave = { ...todoFound, ...todoUpdates };
    assign(todoFound, todoToSave);
});

export { Todo, OwaDate };
